var generic = generic || {};
var site = site || {};
var spp_loyalty_prices_enabled = Drupal.settings.globals_variables.spp_loyalty_prices_enabled || 0;
var disableFB = Drupal.settings.globals_variables.disable_fb_share || 0;
var that;
var enableDeepLink = Drupal?.settings?.globals_variables?.enable_deep_link || 0;
var urlParams = new URLSearchParams(location.search);
var skuSize = urlParams?.get('size');
var skusArray,
  $sizeSelector;

site.product = site.product || {};
site.product.view = site.product.view || {};
site.product.view.full = function(args) {
  that = {
    productData: args.productData,
    productId: args.productData.PRODUCT_ID,
    productCode: args.productData.skus[0].PRODUCT_CODE
  };
  var productName = that.productData.PROD_RGN_NAME;
  var productSubname = that.productData.PROD_RGN_SUBHEADING;
  var product_images = that.productData.XL_IMAGE;
  var enableDiscPrice = Drupal.settings.product_info.show_discount_price;
  var $olapicWidgetNode = $('#olapic_specific_widget');
  var $olapicWidgetWrapperNode = $('.js-olapic-widget');

  if (!args.productData) return null;

  var $productImages = $('.product-full__images');
  $productImage = $('img', $productImages);
  $productImageCount = $productImage.length;

  if ($olapicWidgetWrapperNode.length && $olapicWidgetNode.length) {
    if ($olapicWidgetNode.hasClass('olapic_items_0')) {
      $olapicWidgetNode.closest('.js-olapic-widget').hide();
    } else {
      var observer = new MutationObserver(function(mutationsList) {
        var detectItemClass = $olapicWidgetNode.attr('class').indexOf('olapic_items_');
        for (var mutation in mutationsList) {
          if (detectItemClass !== -1) {
            if ($olapicWidgetNode.hasClass('olapic_items_0')) {
              $olapicWidgetNode.closest('.js-olapic-widget').hide();
            }
            this.disconnect();
          }
        }
      });
      observer.observe($olapicWidgetNode[0], { attributes: true });
    }
  }

  $('.swatch').click(function() {
    var selectedSku = $(this).attr('data-sku-base-id');
    var skuData = _.find(that.productData.skus, function(sku) {
      return sku.SKU_BASE_ID == selectedSku;
    });
    var formattedprice = _.isUndefined(skuData.formattedPrice) ? '' : skuData.formattedPrice;
    var formattedprice2 = '<span class="product__price--non-sale">' + skuData.formattedPrice2 + '</span><span class="product__price--standard product__price--sale">' + skuData.formattedPrice + '</span>';
    var formattedPrice = _.isUndefined(skuData.PRICE2) ? formattedprice : skuData.PRICE2 > skuData.PRICE ? formattedprice2 : formattedprice;
    $.each($('.js-product-full__price'), function(idx, el) {
      var $priceNode = $(el);
      // if nested element, preserve the markup... update the child instead
      // we could descend indefinitely until we hit text, but that's probably overkill right now
      if ($priceNode.children().length && spp_loyalty_prices_enabled) {
        $priceNode.children().first().html(formattedPrice);
      } else {
        $priceNode.html(formattedPrice);
      }
      $(document).trigger('productQV:rendered:LoyaltyPrices:miniBag', $priceNode);
    });
  });

  var isEsteeEdit = $('.product-full').hasClass('product-full--estee-edit');
  var $isSPPage = $('.product-full').length > 0;
  var isSPPVideo = '';
  var esteeEditVideo;

  // add video
  if (isEsteeEdit || $isSPPage) {
    esteeEditVideo = 0;
    try {
      esteeEditVideo = args.productData.VIDEO_FILE[0];
      isSPPVideo = args.productData.VIDEO_FILE[0];
    } catch (e) {}
    if (esteeEditVideo) {
      var videoPath = '/media/export/cms/products/558x768/';
      var videoPathImage = 'el_video_' + args.productData.PRODUCT_ID + '_558x768_0.jpg';
      videoPath = videoPath + videoPathImage;
      var $videoLink = $('<a/>', {
        class: 'video-launcher',
        href: '//www.youtube.com/embed/' + esteeEditVideo + '?autoplay=1',
        html: '<img src="' + videoPath + '" />'
      });
      var $videoImageContainer = $('<div/>', {
        class: 'product-full__image smoosh product-full__video',
        html: $videoLink
      }).attr('data-thumb', videoPath).attr('data-video', esteeEditVideo);
      $productImages.append($videoImageContainer);
      $('.video-launcher').colorbox({iframe: true, width: '100%', height: '100%', className: 'colorbox__estee-edit'});
    }
  }

  var slickToggleTimer1;
  var slickToggleTimer2;

  var startSlider = function() {
    function slickToggle() {
      slickToggleTimer1 = setTimeout(function() {
        $('.product-full__images').slick('slickNext');
        slickToggleTimer2 = setTimeout(function() {
          $('.product-full__images').slick('slickPrev');
        }, 3000);
      }, 3000);
    }
    if ($('.product-full__images').hasClass('slick-slider')) {
      $('.product-full__images').slick('unslick');
    }
    $('.product-full__images').slick({
      dots: true,
      customPaging: function(slider, i) {
        //return '<button type="button">' + (i + 1) + '</button>';
        if (isEsteeEdit) {
          var thumb = $(slider.$slides[i]).data('thumb');
          return '<div class="js-product-image-thumb product-full__image__thumb" style="background-image: url(' + thumb + ')"></div>';
        } else {
          var thumb = $(slider.$slides[i]).find('img').attr('src');
          return '<div class="js-product-image-thumb product-full__image__thumb" style="background-image: url(' + thumb + ')"></div>';
        }
      },
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      rtl: site.direction.isRTL,
      onInit: function(args) {
        var slideLength = args.$slides.length;
        if (slideLength >= 2) {
          slickToggle();
        }
      },
      onBeforeChange: function(args) {},
      onAfterChange: function(args) {}
    });
    // for background
    $(document).on('slick-activated', function(event) {
      var $active = $('.product-full__image.slick-active');
      if ($active.index() === 0) {
        $('.product-full').removeClass('non-bg');
      } else {
        $('.product-full').addClass('non-bg');
      }
    });

    // get SKU Base ID from url and change shade based on that
    var skuBaseIDfromURL = window.location.hash.substr(1);
    if (skuBaseIDfromURL.length > 1) {
      var sppPicker = new site.ShadePicker(that.productData);
      var skuDataFromURL = _.find(that.productData.skus, function(sku) {
        return sku.SKU_BASE_ID == skuBaseIDfromURL;
      });
      if (typeof skuDataFromURL != 'undefined') {
        $productImages.trigger('sku:select', skuDataFromURL);
        sppPicker.updateSwatches(skuBaseIDfromURL);
        sppPicker.updateSelects(skuBaseIDfromURL);
      }
    }
  };

  $productImage.each(function(index, val) {
    var smooshCheck = $(this).attr('src').indexOf('smoosh');
    if (smooshCheck > 1) {
      $(this).parent().addClass('smoosh');
    }
  });

  startSlider();

  $productImages.on('sku:select', function(e, skuData) {
    window.clearTimeout(slickToggleTimer1);
    window.clearTimeout(slickToggleTimer2);
    //update main images
    var newImageArray = [];
    newImageArray = skuData.XL_IMAGE;
    var newSmoosh = skuData.XL_SMOOSH;
    var optionTextHtml;
    var priceAndSizeHtml;

    if (newSmoosh.length) {
      newImageArray.splice(1, 0, newSmoosh);
    }

    // To push product level images into images array
    if (!_.isUndefined(product_images)) {
      if (!_.isNull(product_images) && product_images.length > 0) {
        newImageArray = newImageArray.concat(product_images);
      }
    }
    //getting odd duplicate, make unique
    newImageArray = _.uniq(newImageArray);
    //remove empty elements from array
    newImageArray = newImageArray.filter(function(v) {
      return v !== '';
    });

    //current slide count
    var slideCount = $('.product-full__images .slick-slide').length;
    //create new list
    for (var i = slideCount - 1; i >= 0; i--) {
      $('.product-full__images').slick('slickRemove', i);
    }
    $(newImageArray).each(function(index, val) {
      //add smoosh class
      var smooshClass = val.indexOf('smoosh') > 1 ? 'smoosh' : '';
      //add slide
      var newSlide;
      if (isEsteeEdit || isSPPVideo) {
        newSlide = '<div class="product-full__image ' + smooshClass + '" data-thumb="' + val + '"><img src="' + val + '" /></div>';
      } else {
        newSlide = '<div class="product-full__image ' + smooshClass + '"><img src="' + val + '" alt="' + productName + '" /></div>';
      }
      $('.product-full__images').slick('slickAdd', newSlide);
    });
    if ((isEsteeEdit || isSPPVideo) && esteeEditVideo) {
      $('.product-full__images').slick('slickAdd', $videoImageContainer);
      $('.video-launcher').colorbox({iframe: true, width: '100%', height: '100%', className: 'colorbox__estee-edit'});
    }

    //Down Price Updated for Shaded Products
    var isDiscountable = _.isUndefined(skuData.DISCOUNTABLE) ? 0 : skuData.DISCOUNTABLE;
    var price2 = _.isUndefined(skuData.PRICE2) ? '' : skuData.PRICE2;
    var formattedPrice2 = _.isUndefined(skuData.formattedPrice2) ? '' : skuData.formattedPrice2;
    var formattedPrice = _.isUndefined(skuData.formattedPrice) ? '' : skuData.formattedPrice;
    var productSize = _.isUndefined(skuData.PRODUCT_SIZE) ? '' : skuData.PRODUCT_SIZE;
    var priceNode = $('.js-product-price-size').length ? $('.js-product-price-size') : $('.spp-product__price-size');
    var priceLoyaltyContainer = $('.js-price-loyalty-container', priceNode);
    var priceLoyaltyNode = $('.js-price-loyalty', priceNode).last().clone();
    var $priceAndSizeElem = priceNode.find('.js-product-price-size__wrapper');
    var $priceLoyaltyWrapper = $('.product-full__price-loyalty--text', priceNode);

    $priceLoyaltyWrapper.removeClass('hidden');
    $('.js-non-discount-price', '.js-product-full-description').remove();

    if (price2) {
      productSize = productSize !== null ? productSize + '  ' : '';
      priceAndSizeHtml = productSize + '<span class="product__price--non-sale">' + formattedPrice2 + '</span><span class="on-sale  product__price--sale">' + formattedPrice + '</span>';
      if (priceLoyaltyNode && priceLoyaltyNode.length) {
        priceLoyaltyNode.attr('data-is-discountable', isDiscountable);
        optionTextHtml = '<span class="on-sale  product__price--sale js-price-loyalty">' + formattedPrice + '</span>';
        if (isDiscountable) {
          priceLoyaltyContainer.html(optionTextHtml);
        } else {
          $priceLoyaltyWrapper.addClass('hidden');
          priceNode.append('<span class="js-non-discount-price">' + priceAndSizeHtml + '</span>');
          return;
        }
      }
    } else if (productSize && priceLoyaltyNode && priceLoyaltyNode.length) {
          priceLoyaltyNode.attr('data-is-discountable', isDiscountable);
          var priceLoyaltyText = priceLoyaltyNode.find('.js-price-loyalty--text');
          optionTextHtml = '<span class="product-full__price">' + formattedPrice + '</span>';
          if (!priceNode.hasClass('js-product-multiple-sizes')) {
            optionTextHtml = optionTextHtml + '<span class="product-full__price-psize">' + productSize + '</span>';
          }
          priceLoyaltyText.html(optionTextHtml);
          priceLoyaltyContainer.html(priceLoyaltyNode);
    } else if (priceLoyaltyNode && priceLoyaltyNode.length) {
          priceLoyaltyNode.attr('data-is-discountable', isDiscountable);
          var priceLoyaltyText = priceLoyaltyNode.find('.js-price-loyalty--text');
          optionTextHtml = '<span class="product-full__price">' + formattedPrice + '</span>';
          priceLoyaltyText.html(optionTextHtml);
          priceLoyaltyContainer.html(priceLoyaltyNode);
    }

    productSize = productSize ? productSize + '  ' + formattedPrice : formattedPrice;
    priceAndSizeHtml = priceAndSizeHtml ? priceAndSizeHtml : productSize;

    if ($priceAndSizeElem.length) {
      $priceAndSizeElem.html(priceAndSizeHtml);
    } else if (!priceLoyaltyNode.length) {
      priceNode.html(priceAndSizeHtml);
    }

    $(document).trigger('productQV:rendered:LoyaltyPrices', priceNode);
  });

  // shade filter
  if (that.productData.shaded) {
    var sppPicker = new site.ShadePicker(that.productData);
    var $shadeFilterItem = $('.product-full__shade-filter-item');
    var $swatches = $('.swatch', '.shade-list');

    $shadeFilterItem.click(function(event) {
      $shadeFilterItem.removeClass('is_selected');
      $(this).addClass('is_selected');
      if ($(this).hasClass('all-item')) {
        $swatches.parent().show();
        $swatches.first().click();
      } else if ($(this).hasClass('intensity-item')) {
        var intensity = $(this).attr('data-intensity');
        $swatches.parent().hide();
        var $swatchesFiltered = $swatches.filter('[data-intensity=' + intensity + ']');
        $swatchesFiltered.parent().show();
        $swatchesFiltered.first().click();
      } else if ($(this).hasClass('misc-flag-item')) {
        var miscFlag = $(this).attr('data-misc-flag');
        $swatches.parent().hide();
        var $swatchesFiltered = $swatches.filter('[data-misc-flag=' + miscFlag + ']');
        $swatchesFiltered.parent().show();
        $swatchesFiltered.first().click();
      }
    });
    if (isEsteeEdit && typeof site.product !== 'undefined') {
      if (typeof site.product.view.centerShadePicker !== 'undefined') {
        //center shades
        site.product.view.centerShadePicker($('.product-full--estee-edit'));
      }
      $(window).on('resize', _.debounce(function() {
        if (typeof site.product.view.centerShadePicker !== 'undefined') {
          site.product.view.centerShadePicker($('.product-full--estee-edit'));
        }
      }, 100));
    }
  }

  site.addFavoritesButton($('.js-add-to-favorites'));

  var $quantitySelect = $('.product-full__quantity');
  var $sizeSelect = $('.product-full__price-size-select');
  var $skintypeSelect = $('.product-full__skintype-select');

  // set the default skintype value in the dropdown to match the one set in .net
  // note that the size select keys off of the skincare dropdown, so this must be set first
  if ($skintypeSelect.length) {
    // the default sku
    var defaultSku = args.productData.skus[0].SKU_BASE_ID;

    // get the value for the select with the data-skus attribute matching the default sku
    var defaultSkinTypeValue = $("[data-skus='" + defaultSku + "']").attr('value');

    // if there is also a sizeSelect, there may be a list of skus on the data-skus value, so need to match differently
    if ($sizeSelect.length) {
      $skintypeSelect.find('[data-skus]').each(function(index, selectOption) {
        if ($(selectOption).attr('data-skus')) {
          var skus = $(selectOption).attr('data-skus').split(',');

          $(skus).each(function(index, skuValue) {
            if (skuValue == defaultSku) {
              defaultSkinTypeValue = $(selectOption).attr('value');
            }
          });
        }
      });
    }

    // set that as the value of the select
    $('.product-full__skintype-select').val(defaultSkinTypeValue);

    // update the select box
    $skintypeSelect.selectBox('refresh');
  }

  //size select init:

  //get skus to show from skintype
  //if size exists
  if ($sizeSelect.length && $skintypeSelect.length) {
    function updateSizeSelect() {
      $('option', $sizeSelect).prop('disabled', true);
      var selectedSkus = $skintypeSelect.find('option:selected').attr('data-skus').split(',');
      $(selectedSkus).each(function(index, val) {
        var $option = $('option', $sizeSelect).filter('[data-sku-base-id=' + val + ']');
        $option.prop('disabled', false);
        if (index == 0) {
          $option.prop('selected', true);
        }
      });
      $sizeSelect.trigger('change');
    }
    updateSizeSelect();
  }

  if ($sizeSelect.length) {
    $sizeSelect.selectBox();
    site.product.view.full.updateMarkDownPriceSizeDropDown($sizeSelect);
    if (enableDiscPrice) {
      $sizeSelect.find('option').each(function(index, val) {
        var optionTextHtml = $(val).attr('data-option-text');
        $('ul.product-full__price-size-select-selectBox-dropdown-menu').last().find('li').eq(index).find('a').html(optionTextHtml);
      });
      var optionText = $sizeSelect.find('option:selected').attr('data-option-text');
      $sizeSelect.siblings('a.product-full__price-size-select.selectBox-dropdown').find('span.selectBox-label').html(optionText);
    }
  }

  var $sizeSelectMiniBag = $('.js-mini-price-size-select');

  if ($sizeSelectMiniBag.length > 0) {
    site.product.view.full.updateMarkDownPriceSizeDropDown($sizeSelectMiniBag);
  }

  $sizeSelect.on('change', function() {
    var selectedSku = $(this).find('option:selected').attr('data-sku-base-id');
    if (enableDiscPrice) {
      var optionChangeText = $(this).find('option:selected').attr('data-option-text');
      $(this).siblings('a.product-full__price-size-select.selectBox-dropdown').find('span.selectBox-label').html(optionChangeText);
    }
    var skuData = _.find(that.productData.skus, function(sku) {
      return sku.SKU_BASE_ID == selectedSku;
    });
    site.skuSelect(skuData);
    if (enableDeepLink && skuData?.PRODUCT_SIZE) {
      history.replaceState({}, '', '?size=' + skuData.PRODUCT_SIZE);
    }
  });

  $quantitySelect.change(function(event) {
    var quantity = $(this).val();
    site.qtySelect(that.productId, quantity);
    $('select.spp-product__mini-bag-quantity').val(quantity);
    $('.spp-product__mini-bag-quantity').selectBox('refresh');
  });

  // only use skintype as reference, set sku from size select
  $skintypeSelect.change(function(event) {
    if ($sizeSelect.length) {
      updateSizeSelect();
      $sizeSelect.selectBox('refresh');
    } else {
      var selectedSku = $(this).find('option:selected').attr('data-skus');
      //console.log(selectedSku);
      var skuData = _.find(that.productData.skus, function(sku) {
        return sku.SKU_BASE_ID == selectedSku;
      });
      site.skuSelect(skuData);
    }
  });

  $('.product-full__share').click(function() {
    var url = document.documentURI;
    var title = document.title;
    var img = $('#main img').first().attr('src');

    var twitter_url = 'http://twitter.com/intent/tweet?url=' + encodeURI(url) + '&amp;text=' + encodeURI(title) + '&amp;via=EsteeLauder';
    var facebook_url = 'http://www.facebook.com/sharer.php?u=' + encodeURI(url) + '&amp;t=' + encodeURI(title);

    var pinterest_url = 'http://pinterest.com/pin/create/button/?url=' + encodeURI(url) + '&amp;media=' + encodeURI(window.location.protocol) + '//' + encodeURI(window.location.host) + img + '&amp;description=' + encodeURI(title);

    var instagram_url = 'http://www.instagram.com/?url=' + encodeURI(url) + '&amp;t=' + encodeURI(title);
    var facebookLink = !disableFB ? '<li><a class="social-share__link facebook" href="' + facebook_url + '" target="_blank">' + generic.rb('language').get('fb_txt') + '</a></li>' : '';
    var socialHTML = '<div class="social-share"><h4 class="title">' + generic.rb('language').get('share') + '</h4> <ul>' + facebookLink + '<li><a class="social-share__link twitter" href="' + twitter_url + '" target="_blank">' + generic.rb('language').get('twitter_txt') + '</a></li> <li><a class="social-share__link pinterest" href="' + pinterest_url + '" target="_blank">' + generic.rb('language').get('pin_txt') + '</a></li> <li><a class="social-share__link instagram" href="' + instagram_url + '" target="_blank">' + generic.rb('language').get('instgram_txt') + '</a></li> </ul> </div>';

    $.colorbox({
      html: socialHTML,
      className: 'colorbox--social-share',
      width: '320px',
      height: '200px'
    });
    return false;
  });

  // Add share icons
  //updateSocialLinks();
  var getShortUrl = function(urlIn, callback) {
    // clean up urlIn
    urlIn = urlIn.replace(/#.*/, '');
    // add swatch info
    var skuBaseId = $('.swatch--selected.selected').attr('data-sku-base-id');
    if (skuBaseId) {
      urlIn += '#' + skuBaseId;
    }
    //var accessToken = '76cd85b016e8bd7a08db6ed187302c4ad8da70f2';
    var accessToken = 'f59213cc485198f3cba5dbc55e75bd6891f77ece';
    var apiUrl = 'https://api-ssl.bitly.com/v4/shorten';

    $.ajax({
      beforeSend: function (request) {
        request.setRequestHeader('Authorization', 'Bearer ' + accessToken);
        request.setRequestHeader('Content-Type', 'application/json');
      },
      dataType: 'json',
      type: 'POST',
      url: apiUrl,
      data: JSON.stringify(
        {
          long_url: urlIn,
          domain: 'bit.ly'
        }
      ),
      success: function (response) {
        if (callback) {
          callback(response.link);
        }
      }
    });
  };

  var openSocialMedia = function(newUrl) {
    var deviceAgent = navigator.userAgent;
    var ios = deviceAgent.toLowerCase().match(/(iphone|ipod|ipad)/);
    var win;

    if (!$(this).hasClass('.email')) {
      event.preventDefault();
      var width = 600;
      var height = 750;
      var openUrl = newUrl.replace(/#/g, '%23');

      // Allow for borders.
      var leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
      // Allow for title and status bars.
      var topPosition = (window.screen.height / 2) - ((height / 2) + 50);
      var windowFeatures = 'status=no,height=' + height + ',width=' + width;
      windowFeatures += ',resizable=yes,left=' + leftPosition + ',top=' + topPosition;
      windowFeatures += ',screenX=' + leftPosition + ',screenY=' + topPosition;
      windowFeatures += ',toolbar=no,menubar=no,scrollbars=no,location=no,directories=no';

      if (ios) {
        window.location = openUrl;
      } else {
        win = window.open(openUrl, 'sharer', windowFeatures);
        if (win) {
          win.focus();
        }
      }
    }
  };

  var applySocialMediaOffer = function(offerCode) {
    var signedIn = site.userInfoCookie.getValue('signed_in');
    var isLoyaltyMember = site.userInfoCookie.getValue('is_loyalty_member');

    // if the user is signed in and a loyalty member apply the social media offer
    if (offerCode && parseInt(signedIn) && parseInt(isLoyaltyMember)) {
      var paramObj = {'offer_code': offerCode, 'do_not_defer_messages': 1};

      generic.jsonrpc.fetch({
        method: 'offers.apply',
        params: [paramObj]
      });
    }
  };

  if ($('.product-full__personal').find('.social-share-icons').length > 0) {
    var url = document.documentURI;
    var title = document.title;
    var pName = $.parseHTML(productName);
    pName = $.isArray(pName) ? pName[0].nodeValue : '';
    var pSubname = $.parseHTML(productSubname);
    pSubname = $.isArray(pSubname) ? pSubname[0].nodeValue : '';
    var shareCopyLine1 = site.translations.product.social_share_copy_1 || 'What\'s happening?';
    var shareCopyLine2 = '';
    shareCopyLine2 = site.translations.product.social_share_copy_2 || 'Check out ::product:: from @Esteelauder';
    shareCopyLine2 = shareCopyLine2.replace('::product::', pName);
    var shareCopyLine3 = '';
    var isLoyaltyMember = parseInt(site.userInfoCookie.getValue('is_loyalty_member'));
    if (isLoyaltyMember) {
      shareCopyLine3 = site.translations.product.social_share_loyalty_copy || '(I\'m an E-Lister and may receive loyalty points for sharing.)';
      shareCopyLine3 = '%0A' + encodeURI(shareCopyLine3);
    }

    var subjectLine = site.translations.product.social_share_email_subject || 'Check out ::product:: from Estee Lauder';
    subjectLine = subjectLine.replace('::product::', pName);
    var emailBody = site.translations.product.social_share_email_body || 'I thought you might like this product from Estee Lauder!';
    var email = 'mailto:?to=%20&body=' + encodeURI(emailBody) + '%20' + encodeURI(url) + '&subject=' + encodeURI(subjectLine);
    $('.product-full__personal .social-share-icons .email').attr('href', email);

    var img = $('#main img').first().attr('src');
    var twitter_url = 'http://twitter.com/intent/tweet?url=' + encodeURI(url) + '&text=' + encodeURI(shareCopyLine1) + '%0A' + encodeURI(shareCopyLine2) + shareCopyLine3;
    var facebook_url = 'http://www.facebook.com/sharer.php?u=' + encodeURI(url) + '&quote=' + encodeURI(shareCopyLine1) + '%0A' + encodeURI(shareCopyLine2) + shareCopyLine3;
    var pinterest_url = 'http://pinterest.com/pin/create/button/?url=' + encodeURI(url) + '&media=' + encodeURI(window.location.protocol) + '//' + encodeURI(window.location.host) + img + '&description=' + encodeURI(shareCopyLine1) + '%0A' + encodeURI(shareCopyLine2) + shareCopyLine3;
    var instagram_url = 'http://www.instagram.com/?url=' + encodeURI(url) + '&t=' + encodeURI(shareCopyLine1) + '%0A' + encodeURI(shareCopyLine2);

    $('.product-full__personal .social-share-icons .facebook').attr('href', facebook_url);
    $('.product-full__personal .social-share-icons .twitter').attr('href', twitter_url);
    $('.product-full__personal .social-share-icons .pinterest').attr('href', pinterest_url);
    $('.product-full__personal .social-share-icons .instagram').attr('href', instagram_url);

    if (Drupal.settings.lyl_social_ocodes_enabled && Drupal.settings.lyl_social_ocodes) {
      var ocodes = Drupal.settings.lyl_social_ocodes;
      $('.product-full__personal .social-share-icons .facebook').attr('offer_code', ocodes.facebook);
      $('.product-full__personal .social-share-icons .twitter').attr('offer_code', ocodes.twitter);
      $('.product-full__personal .social-share-icons .pinterest').attr('offer_code', ocodes.pinterest);
      $('.product-full__personal .social-share-icons .instagram').attr('offer_code', ocodes.instagram);
    }

    // facebook
    $('.product-full__personal .social-share-icons .facebook').on('click tap', function(e) {
      e.preventDefault();
      getShortUrl(document.location.href, function(result) {
        var url = result;
        var shadeName = $('.shade-select .selectBox-label :first').text();
        if (shadeName) {
          shareCopyLine2 = site.translations.product.social_share_shaded_copy || 'Check out ::product:: in ::shadename:: from @Esteelauder';
          shareCopyLine2 = shareCopyLine2.replace('::product::', pName + ' ' + pSubname);
          shareCopyLine2 = shareCopyLine2.replace('::shadename::', shadeName);
        }
        var facebook_url = 'http://www.facebook.com/sharer.php?u=' + encodeURI(url) + '&quote=' + encodeURI(shareCopyLine1) + '%0A' + encodeURI(shareCopyLine2) + shareCopyLine3;
        openSocialMedia(facebook_url);
      });
      applySocialMediaOffer($(this).attr('offer_code'));
    });

    // twitter
    $('.product-full__personal .social-share-icons .twitter').on('click tap', function(e) {
      e.preventDefault();
      getShortUrl(document.location.href, function(result) {
        var url = result;
        var shadeName = $('.shade-select .selectBox-label :first').text();
        if (shadeName) {
          shareCopyLine2 = site.translations.product.social_share_shaded_copy || 'Check out ::product:: in ::shadename:: from @Esteelauder';
          shareCopyLine2 = shareCopyLine2.replace('::product::', pName + ' ' + pSubname);
          shareCopyLine2 = shareCopyLine2.replace('::shadename::', shadeName);
        }
        var twitter_url = 'http://twitter.com/intent/tweet?url=' + encodeURI(url) + '&text=' + encodeURI(shareCopyLine1) + '%0A' + encodeURI(shareCopyLine2) + shareCopyLine3;
        openSocialMedia(twitter_url);
      });
      applySocialMediaOffer($(this).attr('offer_code'));
    });

    // pinterest
    $('.product-full__personal .social-share-icons .pinterest').on('click tap', function(e) {
      e.preventDefault();
      getShortUrl(document.location.href, function(result) {
        var url = result;
        var shadeName = $('.shade-select .selectBox-label :first').text();
        if (shadeName) {
          shareCopyLine2 = site.translations.product.social_share_shaded_copy || 'Check out ::product:: in ::shadename:: from @Esteelauder';
          shareCopyLine2 = shareCopyLine2.replace('::product::', pName + ' ' + pSubname);
          shareCopyLine2 = shareCopyLine2.replace('::shadename::', shadeName);
        }
        var pinterest_url = 'http://pinterest.com/pin/create/button/?url=' + encodeURI(url) + '&media=' + encodeURI(window.location.protocol) + '//' + encodeURI(window.location.host) + img + '&description=' + encodeURI(shareCopyLine1) + '%0A' + encodeURI(shareCopyLine2) + shareCopyLine3;
        openSocialMedia(pinterest_url);
      });
      applySocialMediaOffer($(this).attr('offer_code'));
    });
  }

  $(document).on('product.init', function () {
    skusArray = that?.productData?.skus;
    $sizeSelector = $('.product-full__price-size-select', '.product-full');
    if (enableDeepLink && skusArray && $sizeSelector.length) {
      if (skuSize) {
        skusArray.forEach(function (sku) {
          if (sku.PRODUCT_SIZE === skuSize) {
            var $option = $('option', $sizeSelector).filter('[data-sku-base-id=' + sku.SKU_BASE_ID + ']');

            $option?.prop('selected', true);
            $sizeSelector.trigger('change');
            $sizeSelector.selectBox('refresh');
          }
        });
      }
    }
  });

  return that;
};

$('.js-sku-menu').bind('change', function() {
  var sku_id = $(this).val();
  var skuData = _.find(that.productData.skus, function(sku) {
    return JSON.stringify(sku.SKU_BASE_ID) === sku_id;
  });
  var formattedprice = _.isUndefined(skuData.formattedPrice) ? '' : skuData.formattedPrice;
  var formattedprice2 = '<span class="product__price--non-sale">' + skuData.formattedPrice2 + '</span><span class="product__price--standard product__price--sale">' + skuData.formattedPrice + '</span>';
  var formattedPrice = _.isUndefined(skuData.PRICE2) ? formattedprice : skuData.PRICE2 > skuData.PRICE ? formattedprice2 : formattedprice;
  $.each($('.js-product-full__price'), function(idx, el) {
    var $priceNode = $(el);
    // if nested element, preserve the markup... update the child instead
    // we could descend indefinitely until we hit text, but that's probably overkill right now
    if ($priceNode.children().length && spp_loyalty_prices_enabled) {
      $priceNode.children().first().html(formattedPrice);
    } else {
      $priceNode.html(formattedPrice);
    }
    $(document).trigger('productQV:rendered:LoyaltyPrices:miniBag', $priceNode);
  });
});

// Code for updating mark down prices on custom select box
site.product.view.full.updateMarkDownPriceSizeDropDown = function($sizeSelect) {
  var customSizedClass = $sizeSelect.attr('class').split(' ')[0];
  var $customSizedElement = $('.' + customSizedClass + '-selectBox-dropdown-menu');
  var $customSelectBoxControl = $sizeSelect.selectBox('control');
  $sizeSelect.find('option').each(function(index, val) {
    var optionElement = $customSizedElement.last().find('li');
    if (optionElement.hasClass('option-discount-sale')) {
      var optionTextHtml = $(val).attr('data-markdown-price');
      optionElement.eq(index).find('a').html(optionTextHtml);
      $sizeSelect.attr('data-is-markdown-price', 1);
    }
  });
  if ($sizeSelect.attr('data-is-markdown-price')) {
    var optionText = $sizeSelect.find('option:selected').attr('data-markdown-price');
    $customSelectBoxControl.find('span.selectBox-label').html(optionText);
  }
  $sizeSelect.selectBox().on('close', function() {
    if ($(this).attr('data-is-markdown-price')) {
      var optionChangeText = $(this).find('option:selected').attr('data-markdown-price');
      $customSelectBoxControl.find('span.selectBox-label').html(optionChangeText);
    }
  });
};
